import 'zone.js';
import '@angular/localize/init';
(globalThis as any).global = globalThis;
(globalThis as any).process = {
  env: { DEBUG: undefined },
};
